import { HeaderModule } from 'components/header-module'
import Soon from 'components/soon'

const Home = () => {
  return (
    <Soon>
      <HeaderModule.title text='Pagina Inicial' />
    </Soon>
  )
}

export default Home
